import React, { useEffect, useState } from "react";

import { AppLoader } from "../../../common/components/AppLoader";
import { useSprintFetch } from "../../data-access/useSprintFetch";
import { AuthConfig, AuthConfigContext } from "./AuthConfigurationContext";

type AuthConfigurationProviderProps = React.PropsWithChildren<unknown>;

export const AuthConfigurationProvider: React.FunctionComponent<AuthConfigurationProviderProps> = ({
    children
}: AuthConfigurationProviderProps) => {
    const [configuration, setConfiguration] = useState<AuthConfig>();
    const sprintFetch = useSprintFetch({ isPublic: true });

    useEffect(() => {
        sprintFetch
            .httpGet<AuthConfig>(`${process.env.PUBLIC_URL}/api/configuration/public/auth`)
            .then((configJson) => {
                setConfiguration(configJson);
            });
    }, []);

    if (configuration) {
        return <AuthConfigContext.Provider value={configuration}>{children}</AuthConfigContext.Provider>;
    }

    return <AppLoader message="Loading auth configuration..." />;
};
